export const data = [
  {
    id: 1,
    title: 'Что считается «образовательной практикой»?',
    content: 'Это может быть метод, формат, проект или\u00A0событие, которое доказало свою эффективность в\u00A0обучении студентов. Главное — конкретика, результат и\u00A0возможность тиражирования.',
  },
  {
    id: 2,
    title: 'Можно\u00A0ли участвовать победителям и финалистам прошлых лет?',
    content: 'Да, но\u00A0победители и\u00A0финалисты не\u00A0могут подавать на\u00A0конкурс практики, которые уже представляли. Участники, которые не\u00A0вышли в\u00A0финал в\u00A0прошлые годы, могут подать те\u00A0же практики повторно.',
  },
  {
    id: 3,
    title: 'Кто оплачивает проезд в\u00A0Москву?',
    content: 'Обратитесь к\u00A0администрации своей образовательной организации. Мы вышлем официальное письмо-приглашение для\u00A0участников, которые выйдут в\u00A0финал.',
  },
  {
    id: 9,
    title: 'Что делать, если мне не\u00A0удалось выйти в\u00A0финал, но\u00A0всё равно хочется посмотреть на\u00A0практики финалистов?',
    content: 'Заполните специальную форму в\u00A0личном кабинете после подведения итогов, и\u00A0мы направим вам официальное письмо-приглашение на\u00A0финал в\u00A0качестве участника.',
  },
  {
    id: 4,
    title: 'Можно\u00A0ли подать несколько практик от\u00A0одного человека?',
    content: 'Нет, от\u00A0одного участника принимается только одна практика. Пожалуйста, выберите самый сильный и\u00A0значимый опыт, который вы готовы представить на\u00A0конкурсе.',
  },
  {
    id: 5,
    title: 'Кто сможет представить свою практику на\u00A0международном семинаре в\u00A0рамках Транспортной недели?',
    content: 'Выступить на\u00A0международной сессии смогут участники, чьи практики войдут в\u00A0число победителей конкурса и\u00A0будут признаны наиболее перспективными для\u00A0масштабирования и\u00A0обмена опытом на\u00A0международном уровне.',
  },
  {
    id: 6,
    title: 'Где можно отслеживать актуальную информацию о\u00A0сроках этапов конкурса?',
    content: 'Вся информация о\u00A0ключевых датах, этапах конкурса и\u00A0важных новостях публикуется на\u00A0официальном сайте. Чтобы оставаться в\u00A0курсе обновлений рекомендуем подписаться на\u00A0канал конкурса в\u00A0MAX и\u00A0Telegram.',
  },
  {
    id: 7,
    title: 'Как задать вопрос организаторам?',
    content: 'Вопросы можно направлять на\u00A0официальную электронную почту оргкомитета, указанную в\u00A0разделе «Контакты» и\u00A0в\u00A0чат участников в\u00A0MAX.',
  },
  {
    id: 8,
    title: 'Что изменилось в конкурсе в\u00A02026 году?',
    content: 'Теперь на\u00A0равных основаниях в\u00A0конкурсе могут принимать участие преподаватели иностранных транспортных вузов. Участникам также предоставлена возможность указывать несколько соавторов конкурсной практики, что\u00A0позволяет полноценно представить результаты коллективной работы. Для\u00A0всех зарегистрированных участников стала доступна бесплатная программа повышения квалификации по\u00A0инженерной дидактике, пройти которую можно прямо в\u00A0личном кабинете с\u00A0получением удостоверения установленного образца. Этап вебинаров заменён этапом видеопрезентаций. Это решение обеспечивает участникам большую гибкость при\u00A0представлении своих практик и\u00A0позволяет самостоятельно выбирать удобный формат и\u00A0время подготовки материалов. Кроме того, победители и\u00A0финалисты конкурсов прошлых лет не\u00A0могут повторно подавать ранее представленные конкурсные практики. Для участия необходимо заявлять новые или существенно обновлённые разработки.',
  },
];
